__turbopack_context__.v({
  "responsiveDescription": "ContentItemCard-module__7CIaNq__responsiveDescription",
});
